import { LinkCta } from "~/components/LinkCta";
import { HeroHeadingText } from "~/components/HeroHeadingText";
import styles from "./hero.module.css";
import {
  Locale,
  type LocalizedStrings,
  useLocalization,
} from "~/components/localization/LocalizationProvider";

type Localization = {
  title: string;
  cta: string;
};

const englishLocalization: Localization = {
  title: "Transforming the Way You Smile",
  cta: "Why choose us?",
};

const spanishLocalization: Localization = {
  title: "Transformando la manera en que sonríes",
  cta: "¿Por qué elegirnos?",
};

const localized: LocalizedStrings<Localization> = {
  [Locale.EN]: englishLocalization,
  [Locale.ES]: spanishLocalization,
};
export function Hero() {
  const getLocalization = useLocalization(localized);
  const title = getLocalization("title");
  const cta = getLocalization("cta");

  return (
    <section className={styles.hero}>
      <img
        className={styles.heroImage}
        src="/optimized/hero-bg-1170.webp"
        srcSet="/optimized/hero-bg-780.webp 780w, /optimized/hero-bg-1170.webp 1170w, /optimized/hero-bg-1600.webp 1600w"
        sizes="(max-width: 960px) 100vw, 80vw"
        width="1170"
        height="781"
        alt=""
        aria-hidden="true"
        fetchPriority="high"
        decoding="async"
      />
      <div className={styles.heroContent}>
        <h1 className={styles.heroContentText} data-testid="hero-heading">
          <HeroHeadingText title={title} />
        </h1>
        <div className={styles.heroCta}>
          <LinkCta to="/why-choose-us" py="3" px="7">
            {cta}
          </LinkCta>
        </div>
      </div>
    </section>
  );
}
